<template>
  <div class="">
    <v-row class="personal-info-content">
      <v-col cols="12">
        <div class="d-block d-md-flex justify-space-between w-100 align-center">
          <h2 class="group-label flex text-left">Phones</h2>
          <div class="text-left">
            <a @click="addPhone"> Add Phone </a>
          </div>
        </div>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col class="py-0 d-flex justify-space-between">
            <div class="flex">
              <div
                v-for="phone in userPhones"
                :key="phone.id"
                class="mt-3 mt-md-0"
              >
                <div
                  class="d-block d-md-flex align-center justify-space-between"
                >
                  <div class="flex text-left font-15 w-70">
                    {{ phone.phone }}
                  </div>
                  <div class="text-right">
                    <v-btn icon small @click="openEditModal(phone)">
                      <v-icon>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                    <v-btn icon small @click="deleteAndRefresh(phone.id)">
                      <v-icon>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
                <v-divider class="d-block d-md-none"></v-divider>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="showAddModal" width="800">
      <v-form ref="phoneCreateForm" @submit.prevent="createPhone">
        <v-card>
          <v-card-title>
            <span class="headline ml-3">Create Phone</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-tel-field
                    v-model="phone.phone"
                    :rules="phoneRules"
                    label="Phone"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-tel-field>
                </v-col>
                <v-col sm="6" class="d-block d-md-none"></v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="appGreen darken-1" dark type="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="showEditModal" width="800">
      <v-form ref="phoneEditForm" @submit.prevent="editPhone">
        <v-card>
          <v-card-title>
            <span class="headline ml-3">Update Phone</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-tel-field
                    v-model="phone.phone"
                    :rules="phoneRules"
                    label="Phone"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-tel-field>
                </v-col>
                <v-col sm="6" class="d-block d-md-none"></v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="appGreen darken-1" dark type="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import Helpers from "@/mixins/helpers";
export default {
  props: {
    payload: {
      from: 0,
      to: 10,
      userId: null
    }
  },
  mixins: [Helpers],
  data() {
    let vm = this;
    return {
      showAddModal: false,
      showEditModal: false,
      phone: {},
      phoneRules: [
        v => !!v || "Phone is required",
        v => (v && v.length >= 8) || "Phone must be at least 8 characters",
        v => (v && v.length <= 35) || "Phone must be less than 35 characters"
      ]
    };
  },
  computed: {
    userPhones() {
      return this.$store.state.userphones.userPhones;
    },
    totalItems() {
      return this.$store.state.userphones.total;
    }
  },
  created() {
    this.getUserPhones(this.payload);
  },
  methods: {
    addPhone() {
      this.showAddModal = true;
    },
    openEditModal(phone) {
      this.phone = phone;
      this.showEditModal = true;
    },
    async editPhone() {
      if (this.$refs.phoneEditForm.validate()) {
        this.showEditModal = false;
        this.$swal({
          title: "Updating phone",
          html: "This will only take a moment",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("userphones/UPDATE_USER_PHONE", {
          phone: this.phone,
          userId: this.payload.userId
        });
        this.getUserPhones(this.payload);
      }
    },
    async createPhone() {
      if (this.$refs.phoneCreateForm.validate()) {
        this.showAddModal = false;
        this.$swal({
          title: "Creating phones",
          html: "This will only take a moment",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("userphones/CREATE_USER_PHONE", {
          phone: this.phone,
          userId: this.payload.userId
        });
        this.getUserPhones(this.payload);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Phone created successfully",
          icon: "info"
        });
        this.getUserPhones(this.payload);
      }
    },
    async deleteAndRefresh(id) {
      let res = await this.destroyPhone(id);
      if (res) {
        this.getUserPhones(this.payload);
      }
    },
    async destroyPhone(id) {
      let { value } = await this.$swal.fire({
        title: "Delete Phone",
        html: "Are you sure you want to delete this Phone ",
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No"
      });
      if (value) {
        this.$swal({
          title: "Deleting Phone ...",
          html: "this may only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("userphones/DESTROY_USER_PHONE", {
          userId: this.payload.userId,
          id: id
        });
        this.$swal({
          title: "Success",
          html: "Phone has been deleted",
          icon: "info"
        });
        return true;
      }
      return false;
    },
    getUserPhones(payload) {
      this.loading = true;
      this.$store
        .dispatch("userphones/LOAD_USER_PHONES", payload)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$swal("error", error.message, "error");
        });
    }
  }
};
</script>
<style lang="scss">
#users {
  .filters {
    .v-text-field__details {
      display: none;
    }
  }
}
.personal-info {
  .v-input {
    .v-label,
    input {
      font-size: 14px;
    }
  }
  .row {
    &.personal-info-content {
      background-color: white;
      border-radius: 10px;
      @media all and (max-width: 676px) {
        margin: 10px 0 0 0;
        padding: 8px 12px;
        border: none;
      }
      border: 1px solid var(--v-appDarkGrey-base);
      h2 {
        font-family: Gotham-Book;
        font-size: 16px;
      }
      > .col {
        padding: 0;
        > .row {
          > .col-12 {
            @media all and (max-width: 676px) {
              padding: 8px 12px;
            }
            .v-input:not(.v-input--checkbox) {
              border: 1px solid #aaaaaa;
              @media all and (max-width: 676px) {
                border: none;
                .v-input__slot {
                  background: #f2f2f2 !important;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
